import React from 'react';
import PropTypes from 'prop-types';
import { clsHeaderIcon } from '../helpers/TableHelpers';

const TABLE_HEADER = {
  1: 'surveys.type',
  2: 'surveys.completed_at',
  3: 'surveys.score',
}

const ASQSimpleSurveyHeaderSort = ({children, cls = '', idx, onSortChange}) => {
  const key = TABLE_HEADER[idx];
  return (
    <div data-sort={key} className={`o-rtable__cell ${cls}`} onClick={onSortChange}>
      <span data-sort={key} className='o-table-header--sort'>
        {children}
      </span>
    </div>
  )
}

ASQSimpleSurveyHeaderSort.propTypes = {
  children: PropTypes.node,
  cls: PropTypes.string,
  idx: PropTypes.number.isRequired,
  meta: PropTypes.object.isRequired,
  onSortChange: PropTypes.func.isRequired,
};

export default ASQSimpleSurveyHeaderSort;
